var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TextareaAutosize } from 'brg-react-resize-textarea';
import styled, { css } from 'styled-components';
import useCommonProps from '../../../../hooks/useCommonProps';
import { FontSizes } from '../../../../constants/theme';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from '../../../../constants/media';
import { convertMarkdownToHtml, sanitizeInput } from '../../../../utilites/sanitizeInput';
import { LinkTooltip } from './LinkTooltip';
import { LinkField } from './LinkField';
import { getCursorCoordinates } from '../utils/getCursorCoordinates';
import { normalizeUrl } from '../utils/normalizeUrl';
export var TEXTAREA_TYPE = {
    bibliography: 'bibliography'
};
var SmoothTextArea = styled(TextareaAutosize)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  //transition: all 1.5s ease-out;\n  resize: none;\n  // position: absolute;\n  top: 0;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n    ", "\n  }\n"], ["\n  //transition: all 1.5s ease-out;\n  resize: none;\n  // position: absolute;\n  top: 0;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n    ", "\n  }\n"])), function (_a) {
    var type = _a.type;
    return type === TEXTAREA_TYPE.bibliography && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    textarea {\n      font-size: ", "px;\n      line-height: ", "px;\n    }\n  "], ["\n    textarea {\n      font-size: ", "px;\n      line-height: ", "px;\n    }\n  "])), FontSizes.common.m.fs, FontSizes.common.m.lh);
}, function (_a) {
    var postType = _a.postType, viewType = _a.viewType;
    return postType === 'colored' && ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(viewType) ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: 42px;\n      line-height: 48px;\n      letter-spacing: -0.84px;\n      padding-right: 1px !important;\n  "], ["\n      font-size: 42px;\n      line-height: 48px;\n      letter-spacing: -0.84px;\n      padding-right: 1px !important;\n  "]))) : postType === 'caption' ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", "px !important;\n      line-height: ", "px !important;\n  "], ["\n      font-size: ", "px !important;\n      line-height: ", "px !important;\n  "])), FontSizes.captionText.m.fs, FontSizes.captionText.m.lh) : null;
}, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (p) { return !p.type && ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(p === null || p === void 0 ? void 0 : p.viewType) ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", "px !important;\n    line-height: ", "px !important;\n    letter-spacing: -0.02em;\n  "], ["\n    font-size: ", "px !important;\n    line-height: ", "px !important;\n    letter-spacing: -0.02em;\n  "])), (p === null || p === void 0 ? void 0 : p.postType) === 'normal' ? FontSizes.regularText.m.fs : (p === null || p === void 0 ? void 0 : p.postType) === 'caption' ? FontSizes.captionText.m.fs : FontSizes.bigText.m.fs, (p === null || p === void 0 ? void 0 : p.postType) === 'normal' ? FontSizes.regularText.m.lh : (p === null || p === void 0 ? void 0 : p.postType) === 'caption' ? FontSizes.captionText.m.lh : FontSizes.bigText.m.lh) : null; });
var Wrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  transition: height 0.8s ease-out;\n  overflow-y: hidden;\n  min-height: ", "px;\n  ", "\n"], ["\n  position: relative;\n  transition: height 0.8s ease-out;\n  overflow-y: hidden;\n  min-height: ", "px;\n  ", "\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.minHeight) ? p === null || p === void 0 ? void 0 : p.minHeight : 200; }, function (_a) {
    var showLinkTooltip = _a.showLinkTooltip;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    overflow-y: unset;\n  "], ["\n    overflow-y: unset;\n  "])));
});
var TextArea = function (_a) {
    var onResize = _a.onResize, type = _a.type, onChange = _a.onChange, minHeight = _a.minHeight, _b = _a.additionalInputHeight, additionalInputHeight = _b === void 0 ? 62 : _b, props = __rest(_a, ["onResize", "type", "onChange", "minHeight", "additionalInputHeight"]);
    var container = useRef();
    var textarea = useRef();
    var _c = useState(null), selectedText = _c[0], setSelectedText = _c[1];
    var _d = useState({ x: 0, y: 0 }), tooltipPosition = _d[0], setTooltipPosition = _d[1];
    var _e = useState(false), showLinkTooltip = _e[0], setShowLinkTooltip = _e[1];
    var _f = useState(false), showLinkField = _f[0], setShowLinkField = _f[1];
    var _g = useState(''), link = _g[0], setLink = _g[1];
    var _h = useState(null), selectionRange = _h[0], setSelectionRange = _h[1];
    var _j = useCommonProps(), viewType = _j.viewType, fixedRatio = _j.fixedRatio;
    var postType = useMemo(function () { var _a; return ((_a = ['normal', 'normal_image', 'normal_card', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(props.postType)) ? 'normal' : props === null || props === void 0 ? void 0 : props.postType; }, [props]);
    var handleResize = function (e) {
        container.current.style.height = "".concat(e.target.offsetHeight + 62, "px");
        e.target.scrollTo(0, 0);
        if (onResize) {
            onResize(e);
        }
    };
    var restoreSelection = function () {
        if (textarea.current && selectionRange) {
            var textareaEl = textarea.current.querySelector('textarea');
            if (textareaEl) {
                textareaEl.focus();
                textareaEl.setSelectionRange(selectionRange.start, selectionRange.end);
            }
        }
    };
    var handleChange = function (e) {
        if (onChange) {
            var markdownValue = convertMarkdownToHtml(e.target.value);
            // Очищаем ввод от неразрешенных HTML тегов
            var cleanedValue = sanitizeInput(markdownValue);
            e.target.value = cleanedValue;
            onChange(e);
        }
    };
    var handleSelection = function (e) {
        var textareaEl = e.target;
        var start = textareaEl.selectionStart;
        var end = textareaEl.selectionEnd;
        var selected = textareaEl.value.substring(start, end);
        setSelectedText(selected);
        setSelectionRange({ start: start, end: end });
        if (start !== end && textarea.current) {
            var coordinates = getCursorCoordinates(textareaEl, container.current);
            setTooltipPosition({
                x: coordinates.x,
                y: coordinates.y - 42
            });
        }
    };
    useEffect(function () {
        if (selectedText === null || selectedText === void 0 ? void 0 : selectedText.length) {
            setShowLinkTooltip(true);
            restoreSelection();
        }
        else {
            setShowLinkTooltip(false);
        }
    }, [selectedText]);
    var handleLink = function () {
        setShowLinkField(true);
        restoreSelection();
    };
    var handleClickOutside = function (e) {
        if (textarea.current && !textarea.current.contains(e.target)) {
            setShowLinkTooltip(false);
            setSelectedText('');
            setTooltipPosition({ x: 0, y: 0 });
        }
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () { return document.removeEventListener('mousedown', handleClickOutside); };
    }, []);
    useEffect(function () {
        container.current.style.height = "".concat(textarea.current.offsetHeight + 62, "px");
    }, []);
    useEffect(function () {
        if (!showLinkTooltip) {
            setShowLinkField(false);
        }
    }, [showLinkTooltip]);
    var applyLink = function () {
        if (link && selectedText) {
            var normalizedLink = normalizeUrl(link);
            var newText = props.value.replace(selectedText, "<a href=\"".concat(normalizedLink, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(selectedText, "</a>"));
            var markdownValue = convertMarkdownToHtml(newText);
            onChange({ target: { value: markdownValue } });
            setLink('');
            setShowLinkField(false);
            setShowLinkTooltip(false);
            setSelectionRange(null);
        }
    };
    return (React.createElement(Wrapper, { minHeight: minHeight, ref: container, className: 'textarea-wrapper', showLinkTooltip: showLinkTooltip },
        React.createElement("div", { ref: textarea },
            React.createElement(SmoothTextArea, __assign({ type: type }, props, { postType: postType, viewType: viewType, onResize: handleResize, onChange: handleChange, onSelect: handleSelection, onMouseUp: handleSelection })),
            showLinkTooltip && React.createElement(LinkTooltip, { position: tooltipPosition, onAddLink: handleLink }),
            showLinkField && React.createElement(LinkField, { value: link, onChange: function (e) { return setLink(e.target.value); }, onApply: applyLink }))));
};
export default TextArea;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=TextArea.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TextareaAutosize } from 'brg-react-resize-textarea';
import styled, { css } from 'styled-components';
import useCommonProps from '../../../../hooks/useCommonProps';
import { FontSizes } from '../../../../constants/theme';
import { MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from '../../../../constants/media';
import { convertMarkdownToHtml, sanitizeInput } from '../../../../utilites/sanitizeInput';
import { LinkTooltip } from './LinkTooltip';
import { LinkField } from './LinkField';
import { getCursorCoordinates } from '../utils/getCursorCoordinates';
import { normalizeUrl } from '../utils/normalizeUrl';
export var TEXTAREA_TYPE = {
    bibliography: 'bibliography'
};
var SmoothTextArea = styled(TextareaAutosize)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  //transition: all 1.5s ease-out;\n  resize: none;\n  // position: absolute;\n  top: 0;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n    ", "\n  }\n"], ["\n  //transition: all 1.5s ease-out;\n  resize: none;\n  // position: absolute;\n  top: 0;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n    ", "\n  }\n"])), function (_a) {
    var type = _a.type;
    return type === TEXTAREA_TYPE.bibliography && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    textarea {\n      font-size: ", "px;\n      line-height: ", "px;\n    }\n  "], ["\n    textarea {\n      font-size: ", "px;\n      line-height: ", "px;\n    }\n  "])), FontSizes.common.m.fs, FontSizes.common.m.lh);
}, function (_a) {
    var postType = _a.postType, viewType = _a.viewType;
    return postType === 'colored' && ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(viewType) ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: 42px;\n      line-height: 48px;\n      letter-spacing: -0.84px;\n      padding-right: 1px !important;\n  "], ["\n      font-size: 42px;\n      line-height: 48px;\n      letter-spacing: -0.84px;\n      padding-right: 1px !important;\n  "]))) : postType === 'caption' ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", "px !important;\n      line-height: ", "px !important;\n  "], ["\n      font-size: ", "px !important;\n      line-height: ", "px !important;\n  "])), FontSizes.captionText.m.fs, FontSizes.captionText.m.lh) : null;
}, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (p) { return !p.type && ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small'].includes(p === null || p === void 0 ? void 0 : p.viewType) ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", "px !important;\n    line-height: ", "px !important;\n    letter-spacing: -0.02em;\n  "], ["\n    font-size: ", "px !important;\n    line-height: ", "px !important;\n    letter-spacing: -0.02em;\n  "])), (p === null || p === void 0 ? void 0 : p.postType) === 'normal' ? FontSizes.regularText.m.fs : (p === null || p === void 0 ? void 0 : p.postType) === 'caption' ? FontSizes.captionText.m.fs : FontSizes.bigText.m.fs, (p === null || p === void 0 ? void 0 : p.postType) === 'normal' ? FontSizes.regularText.m.lh : (p === null || p === void 0 ? void 0 : p.postType) === 'caption' ? FontSizes.captionText.m.lh : FontSizes.bigText.m.lh) : null; });
var Wrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  transition: height 0.8s ease-out;\n  overflow-y: hidden;\n  min-height: ", "px;\n  ", "\n"], ["\n  position: relative;\n  transition: height 0.8s ease-out;\n  overflow-y: hidden;\n  min-height: ", "px;\n  ", "\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.minHeight) ? p === null || p === void 0 ? void 0 : p.minHeight : 200; }, function (_a) {
    var showLinkTooltip = _a.showLinkTooltip;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    overflow-y: unset;\n  "], ["\n    overflow-y: unset;\n  "])));
});
var TextArea = function (_a) {
    var onResize = _a.onResize, type = _a.type, onChange = _a.onChange, minHeight = _a.minHeight, _b = _a.additionalInputHeight, additionalInputHeight = _b === void 0 ? 62 : _b, props = __rest(_a, ["onResize", "type", "onChange", "minHeight", "additionalInputHeight"]);
    var container = useRef();
    var textarea = useRef();
    var _c = useState(null), selectedText = _c[0], setSelectedText = _c[1];
    var _d = useState({ x: 0, y: 0 }), tooltipPosition = _d[0], setTooltipPosition = _d[1];
    var _e = useState(false), showLinkTooltip = _e[0], setShowLinkTooltip = _e[1];
    var _f = useState(false), showLinkField = _f[0], setShowLinkField = _f[1];
    var _g = useState(''), link = _g[0], setLink = _g[1];
    var _h = useState(null), selectionRange = _h[0], setSelectionRange = _h[1];
    var _j = useCommonProps(), viewType = _j.viewType, fixedRatio = _j.fixedRatio;
    var postType = useMemo(function () { var _a; return ((_a = ['normal', 'normal_image', 'normal_card', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(props.postType)) ? 'normal' : props === null || props === void 0 ? void 0 : props.postType; }, [props]);
    var handleResize = function (e) {
        container.current.style.height = "".concat(e.target.offsetHeight + 62, "px");
        e.target.scrollTo(0, 0);
        if (onResize) {
            onResize(e);
        }
    };
    var restoreSelection = function () {
        if (textarea.current && selectionRange) {
            var textareaEl = textarea.current.querySelector('textarea');
            if (textareaEl) {
                textareaEl.focus();
                textareaEl.setSelectionRange(selectionRange.start, selectionRange.end);
            }
        }
    };
    var handleChange = function (e) {
        if (onChange) {
            var markdownValue = convertMarkdownToHtml(e.target.value);
            // Очищаем ввод от неразрешенных HTML тегов
            var cleanedValue = sanitizeInput(markdownValue);
            e.target.value = cleanedValue;
            onChange(e);
        }
    };
    var handleSelection = function (e) {
        var textareaEl = e.target;
        var start = textareaEl.selectionStart;
        var end = textareaEl.selectionEnd;
        var selected = textareaEl.value.substring(start, end);
        setSelectedText(selected);
        setSelectionRange({ start: start, end: end });
        if (start !== end && textarea.current) {
            var coordinates = getCursorCoordinates(textareaEl, container.current);
            setTooltipPosition({
                x: coordinates.x,
                y: coordinates.y - 42
            });
        }
    };
    useEffect(function () {
        if (selectedText === null || selectedText === void 0 ? void 0 : selectedText.length) {
            setShowLinkTooltip(true);
            restoreSelection();
        }
        else {
            setShowLinkTooltip(false);
        }
    }, [selectedText]);
    var handleLink = function () {
        setShowLinkField(true);
        restoreSelection();
    };
    var handleClickOutside = function (e) {
        if (textarea.current && !textarea.current.contains(e.target)) {
            setShowLinkTooltip(false);
            setSelectedText('');
            setTooltipPosition({ x: 0, y: 0 });
        }
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () { return document.removeEventListener('mousedown', handleClickOutside); };
    }, []);
    useEffect(function () {
        container.current.style.height = "".concat(textarea.current.offsetHeight + 62, "px");
    }, []);
    useEffect(function () {
        if (!showLinkTooltip) {
            setShowLinkField(false);
        }
    }, [showLinkTooltip]);
    var applyLink = function () {
        if (link && selectedText) {
            var normalizedLink = normalizeUrl(link);
            var newText = props.value.replace(selectedText, "<a href=\"".concat(normalizedLink, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(selectedText, "</a>"));
            var markdownValue = convertMarkdownToHtml(newText);
            onChange({ target: { value: markdownValue } });
            setLink('');
            setShowLinkField(false);
            setShowLinkTooltip(false);
            setSelectionRange(null);
        }
    };
    return (React.createElement(Wrapper, { minHeight: minHeight, ref: container, className: 'textarea-wrapper', showLinkTooltip: showLinkTooltip },
        React.createElement("div", { ref: textarea },
            React.createElement(SmoothTextArea, __assign({ type: type }, props, { postType: postType, viewType: viewType, onResize: handleResize, onChange: handleChange, onSelect: handleSelection, onMouseUp: handleSelection })),
            showLinkTooltip && React.createElement(LinkTooltip, { position: tooltipPosition, onAddLink: handleLink }),
            showLinkField && React.createElement(LinkField, { value: link, onChange: function (e) { return setLink(e.target.value); }, onApply: applyLink }))));
};
export default TextArea;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=TextArea.js.map